/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import SrButton, { SR_BUTTON_THEME_ADOBE_GREY } from 'client/components/SrButton/SrButton';
import SrSafariToolbarSpace from 'client/components/SrSafariToolbarSpace';

import './UPResidualUtilityFaqModal.less';

const UPResidualUtilityFaqModal = ({ onClose }) => {
  return (
    <SrModalV2
      showCloseButton={false}
      theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
      onClose={onClose}
      contentPadding="0px 11px"
      contentMaxWidth="555px"
    >
      <div styleName="faqTitleBox">
        <span styleName="faqTitle">
          How It Works:
          <br />
          Internet Amenity
        </span>
      </div>
      <div styleName="cardBox">
        <p>
          Why is the internet required?
          <br />
          Your Property Manager has provided you with an easy set-up for reliable, lightning fast
          internet. This is one less thing to worry about during your move!
          <br />
          <br />
          Is this a mandatory part of the lease agreement?
          <br />
          Yes, you are required to use one of the available internet options in the link provided to
          you from your property manager.
          <br />
          <br />
          What happens if I already have an internet provider?
          <br />
          You will need to cancel your current internet and select from the available options within
          the link.
          <br />
          <br />
          What are my options for internet providers?
          <br />
          Please take a look at your internet tab within the link. You’ll see all of your available
          options.
          <br />
          <br />
          Do I have to use a specific provider?
          <br />
          Yes, please select from the available options within your link.
          <br />
          <br />
          How is the internet billed?
          <br />
          This will be a monthly charge that comes from your property manager. Check with them for
          more information.
          <br />
          <br />
          Is the cost included in my rent, or will I receive a separate bill?
          <br />
          This can depend on your property manager, please verify this information with them
          directly.
          <br />
          <br />
          How do I set up payments?
          <br />
          This can depend on your property manager, please verify this information with them
          directly.
          <br />
          <br />
          What do I need to do to activate my internet?
          <br />
          Please follow the steps included within the link and look out for next steps after
          selecting your internet plan.
          <br />
          <br />
          Is the internet pre-installed?
          <br />
          This can vary from home to home. Your home is wired and eligible for fiber internet, but
          you may need to have a modem/router installed.
          <br />
          <br />
          Will I need equipment, such as a modem or router?
          <br />
          Yes, you will need new equipment for your internet. Do not use your old equipment.
          <br />
          <br />
          What if I don’t want the internet?
          <br />
          Please reach out to your property manager to discuss alternative options.
          <br />
          <br />
          Can I opt out or decline this service?
          <br />
          Please reach out to your property manager to discuss alternative options.
          <br />
          <br />
          Who do I contact for support or troubleshooting?
          <br />
          Contact the internet provider directly for support and/or troubleshooting.
        </p>
      </div>
      <div styleName="buttonContent">
        <div styleName="buttonBox">
          <SrButton onClick={onClose} theme={SR_BUTTON_THEME_ADOBE_GREY}>
            Close
          </SrButton>
        </div>
      </div>
      <SrSafariToolbarSpace />
    </SrModalV2>
  );
};

UPResidualUtilityFaqModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

UPResidualUtilityFaqModal.displayName = 'UPResidualUtilityFaqModal';

export default UPResidualUtilityFaqModal;
